import { useTranslation } from "react-i18next";

const VerticalNavMenuSectionHeader = ({ item }) => {
  const { t } = useTranslation();
  return (
    <li className="navigation-header d-flex align-items-center" style={{ marginTop: 24 }}>
      {item.icon}
      <span>{t(item.header)}</span>
    </li>
  );
};

export default VerticalNavMenuSectionHeader;
